module.exports = __webpack_public_path__ + "static/media/Nota transforma el sabor de tus antojos con Mayosabores.7760c394.png";